// src/pages/Welcome/StatsSection.jsx
import React from 'react';
import { COLORS, TYPOGRAPHY, LAYOUT, CARD_STYLES } from '../../constants';
import { TrendingUpIcon, CommunityIcon, ShieldCheckIcon } from '../../components/Icons';

const StatsSection = () => {
  const stats = [
    {
      id: 1,
      icon: CommunityIcon,
      value: "Growing",
      label: "Community",
      description: "Trusted ISU students buying and selling on campus"
    },
    {
      id: 2,
      icon: TrendingUpIcon,
      value: "Secure",
      label: "Transactions",
      description: "Safe and reliable marketplace for the ISU community"
    },
    {
      id: 3,
      icon: ShieldCheckIcon,
      value: "Verified",
      label: "Members Only",
      description: "Exclusive access for ISU community members"
    }
  ];

  const sectionStyle = {
    padding: `${LAYOUT.sectionSpacing} ${LAYOUT.containerPadding}`,
    backgroundColor: COLORS.grayLight,
    position: 'relative',
    overflow: 'hidden',
  };

  const containerStyle = {
    maxWidth: LAYOUT.maxWidth,
    margin: '0 auto',
    position: 'relative',
    zIndex: 2,
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: LAYOUT.spacing.xxxl,
  };

  const titleStyle = {
    ...TYPOGRAPHY.heading1,
    color: COLORS.text.primary,
    marginBottom: LAYOUT.spacing.lg,
    fontSize: 'clamp(2rem, 4vw, 2.5rem)',
    fontWeight: '700',
  };

  const subtitleStyle = {
    ...TYPOGRAPHY.body,
    color: COLORS.text.secondary,
    fontSize: 'clamp(1.1rem, 2vw, 1.25rem)',
    maxWidth: '600px',
    margin: '0 auto',
    lineHeight: '1.6',
  };

  const statsGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: LAYOUT.spacing.xl,
    alignItems: 'stretch',
  };

  const statCardStyle = {
    ...CARD_STYLES.base,
    padding: LAYOUT.spacing.xxl,
    textAlign: 'center',
    position: 'relative',
    transition: 'all 0.3s ease',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
  };

  const iconContainerStyle = {
    width: '72px',
    height: '72px',
    borderRadius: LAYOUT.borderRadius.full,
    backgroundColor: COLORS.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: `0 auto ${LAYOUT.spacing.xl} auto`,
    boxShadow: `0 4px 16px ${COLORS.shadow}`,
  };

  const valueStyle = {
    ...TYPOGRAPHY.heading1,
    color: COLORS.primary,
    fontSize: 'clamp(2rem, 4vw, 2.5rem)',
    fontWeight: '700',
    marginBottom: LAYOUT.spacing.md,
  };

  const labelStyle = {
    ...TYPOGRAPHY.heading3,
    color: COLORS.text.primary,
    fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
    fontWeight: '600',
    marginBottom: LAYOUT.spacing.md,
  };

  const descriptionStyle = {
    ...TYPOGRAPHY.body,
    color: COLORS.text.secondary,
    fontSize: '16px',
    lineHeight: '1.6',
    maxWidth: '280px',
    margin: '0 auto',
  };

  return (
    <section style={sectionStyle}>
      <div style={containerStyle}>
        <div style={headerStyle}>
          <h2 style={titleStyle}>Built for ISU Community</h2>
          <p style={subtitleStyle}>
            A trusted marketplace designed specifically for Illinois State University students
          </p>
        </div>

        <div style={statsGridStyle}>
          {stats.map((stat) => {
            const IconComponent = stat.icon;
            
            return (
              <div 
                key={stat.id} 
                style={statCardStyle}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 16px 48px rgba(0, 0, 0, 0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.08)';
                }}
              >
                <div style={iconContainerStyle}>
                  <IconComponent size={36} color="white" fill="white" style={{ color: 'white !important', fill: 'white !important' }} />
                </div>
                
                <div style={valueStyle}>{stat.value}</div>
                <h3 style={labelStyle}>{stat.label}</h3>
                <p style={descriptionStyle}>{stat.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;